export default {
	props: {
		/**
		 * Background property.
		 * `tint1`, `tint2` etc. from `$background in _colors.scss` are available.
		 */
		background: String,

		/**
		 * Elevation of the Pane.
		 * Values: 0, 1, 2, 3, 4.
		 */
		elevation: {
			type: String,
			validator: function(value) {
				// The value must match one of these strings
				return [ '0', '1', '2', '3', '4' ].indexOf(value) !== -1;
			}
		},
		/**
		 * Elevation of the Pane on hover.
		 * Values: 0, 1, 2, 3, 4.
		 */
		elevationHover: {
			type: String,
			validator: function(value) {
				// The value must match one of these strings
				return [ '0', '1', '2', '3', '4' ].indexOf(value) !== -1;
			}
		},
		/**
		 * Elevation of the Pane on click.
		 * Values: 0, 1, 2, 3, 4.
		 */
		elevationActive: {
			type: String,
			validator: function(value) {
				// The value must match one of these strings
				return [ '0', '1', '2', '3', '4' ].indexOf(value) !== -1;
			}
		},
		/**
		 * Can be one of the following values: muted, default.
		 */
		border: [String],

		/**
		 * Can be one of the following values: muted, default.
		 */
		borderTop: [String],

		/**
		 * Can be one of the following values: muted, default.
		 */
		borderRight: [String],

		/**
		 * Can be one of the following values: muted, default.
		 */
		borderBottom: [String],

		/**
		 * Can be one of the following values: muted, default.
		 */
		borderLeft: [String],
		/**
		 * Can be any html/css border-radius
		 */
		borderRadius: [String],
		/**
		 * Can be any html/css width
		 */
		width: [String],
		/**
		 * Can be any html/css height
		 */
		height: [String],
		/**
		 * Centers the content
		 */
		center: Boolean,
		/**
		 * Key to trigger transition.
		 */
		transitionKey: {
			type: String,
			default: 'disabled'
		}
	},
};